<script lang="ts">
    
    import { Badge, Icon } from "sveltestrap";
    import type { FormMember } from "../../Model/FormMember";
    import type { ReadableStore } from "../../Model/ReadableStore";
    import UserName from "../UserName.svelte";

    export let member: FormMember;

    let isSigned: ReadableStore<boolean>;

    $: setupMember(member);

    function setupMember(member: FormMember): void {
        isSigned = member.isSignedReadable;
    }

</script>

<div class="flex-view">
    <div>
        <Icon name={member.isOwner ? "person-circle" : "person-fill"} />
        
        {#if member.isOwner}
            <span class="fw-bold"><UserName id={member.userId} /></span>
        {:else}
            <UserName id={member.userId} />
        {/if}
        
        {#if  member.buddyId}
            <Badge pill color="warning">
                <Icon name="shield-lock-fill" />
                <UserName id={member.buddyId} />
            </Badge>
        {/if}
        
    </div>

    <div class="float-end">
        {#if $isSigned}
        <Icon name="patch-check" />
        {/if}
    </div>
</div>


<style lang="scss">

    .flex-view{
        display: flex;
        justify-content: space-between;
        align-items: center;
    }

</style>